import { __module as e } from "./ghl-ui.es1732.js";
import { i } from "./ghl-ui.es1541.js";
import { b as s } from "./ghl-ui.es1733.js";
(function(m, t) {
  var o = i.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = o(s), r = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, d = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, l = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, f = {
    date: (0, a.default)({
      formats: r,
      defaultWidth: "full"
    }),
    time: (0, a.default)({
      formats: d,
      defaultWidth: "full"
    }),
    dateTime: (0, a.default)({
      formats: l,
      defaultWidth: "full"
    })
  }, u = f;
  t.default = u, m.exports = t.default;
})(e, e.exports);
var p = e.exports;
export {
  p as f
};
